export async function getCurrentLocation(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async position => {
        const { latitude, longitude } = position.coords;

        if (!window.google?.maps?.Geocoder) {
          reject(new Error('Google Maps Geocoder not available'));
          return;
        }

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode(
          { location: { lat: latitude, lng: longitude } },
          (results, status) => {
            if (status === 'OK' && results?.[0]) {
              resolve(results[0].formatted_address);
            } else {
              reject(new Error(`Geocoding failed: ${status}`));
            }
          },
        );
      },
      error => {
        reject(error);
      },
    );
  });
}
